import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { EvidenceRepositoryPage } from '@/features/evidence-logs';
import i18n from '@/lib/i18n';

const evidenceRepositorySearchSchema = z.object({
  page: z.coerce.number().optional().default(1),
  query: z.string().optional(),
  sourceModule: z.string().optional(),
  evidenceType: z.string().optional(),
  owner: z.string().optional(),
  linkedControl: z.string().optional(),
  linkedFramework: z.string().optional(),
  reviewStatus: z.string().optional(),
  approvalStatus: z.string().optional(),
  collectionMethod: z.string().optional(),
  expiryStatus: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  linkedObjectType: z.string().optional(),
  automationClass: z.string().optional(),
  unlinkedOnly: z.coerce.boolean().optional().default(false),
  sortBy: z
    .enum(['last_updated', 'collected_at', 'expires_at', 'title', 'relation_count'])
    .optional()
    .default('last_updated'),
  sortOrder: z.enum(['asc', 'desc']).optional().default('desc'),
  selected: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/evidence/repository')({
  validateSearch: evidenceRepositorySearchSchema,
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.evidenceRepository'),
  }),
  component: EvidenceRepositoryRoute,
});

function EvidenceRepositoryRoute() {
  return <EvidenceRepositoryPage />;
}
